import { render } from "./ContactList.vue?vue&type=template&id=22b69abb"
import script from "./ContactList.vue?vue&type=script&lang=js"
export * from "./ContactList.vue?vue&type=script&lang=js"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__